export default "__VITE_ASSET__BrECY3SN__"